import styled from 'styled-components'

const ModalPrizePoolStyled = styled.div`
  width: 552px;
  position: relative;
  background-color: #4df285;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;

  .user-create_race-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 20px 30px;
    position: relative;
    min-height: 300px;
    min-width: 550px;
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 1;
    }

    .line-condition {
      border-bottom: 2px solid ${({ theme }) => theme.color.lightGreen};
    }

    .height-85 {
      height: 90px;
    }

    .height-45 {
      height: 45px;
    }

    .title-create-race-container {
      /* padding-bottom: 10px; */
      font-size: 30px;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }

    .create-race-container {
      display: flex;
      align-items: center;

      .prize-container {
        width: 100%;
        margin: 30px 30px 5px;
      }

      .ant-form {
        width: 100%;
      }

      .color-DEDEDE {
        color: #DEDEDE;
      }

      .box-prize {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .title-label {
          display: flex;
          align-items: center;
          font-size: 18px;
          width: 30%;
        }

        .input-prize {
          flex: 1;
        }

        .ant-form-item {
          margin: 0;
        }
      }

      .btn-create {
        display: flex;
        justify-content: center;
        padding-top: 10px;
        width: 100%;
        gap: 20px;

        .ant-form-item {
          margin: 0;
        }
      }
    }

    .disabled_text {
      opacity: 0.3;
    }
  }
`

export default ModalPrizePoolStyled
